// @flow

import React from 'react';
import { Tracking } from 'web-core/src/tracking';
import Translate from 'client/components/translate';
import HtmlHead from 'client/components/htmlHead';
import LinkButton from 'client/components/button/linkButton';
import BottomBarContainer from 'client/components/bottomBarContainer';
import FullFooter from 'client/components/footer/full';
import GuideBody from './guideBody';
import LeftNav from './leftNav';
import '../styles/guide.scss';

/* eslint-disable react/no-danger */

type Props = {
  healthGuide: Object,
  removeHealthGuide: Function,
  params: {
    section: string,
    subsection: string,
  },
  translations: {
    healthGuide: Object,
  },
};

const ctaButtonProps = {
  className: 'cta-button auto',
};

// Need some clarification on how we want to track this
const trackAction = (type) => {
  Tracking.track('Health Insurance Guide: Action', { Type: type });
};

class Guide extends React.Component<Props> {
  UNSAFE_componentWillMount() {
    this.bottomBarContent = (
      <div className="center-col flex-row center">
        <LinkButton
          href="/shop/location"
          {...ctaButtonProps}
          onClick={() => trackAction('onboarding-funnel')}>
          <Translate path="healthGuide.cta" />
        </LinkButton>
      </div>
    );
  }

  componentWillUnmount() {
    this.props.removeHealthGuide();
  }

  bottomBarContent: React$Element<'div'>;

  render() {
    const currentSection = this.props.params.section;
    const currentSubsection = this.props.params.subsection;
    const sections = this.props.healthGuide.data.pages;

    const sectionPage = currentSection
      ? this.props.healthGuide.data.pages.filter(page => page.key === currentSection)[0]
      : this.props.healthGuide.data;

    const sectionHeader = sectionPage.title || 'Insurance guide';

    const subsectionPage = currentSubsection
      ? sectionPage.pages.filter(page => page.key === currentSubsection)[0]
      : null;

    const healthGuideTranslations = this.props.translations.healthGuide;

    const currentPageTitle = subsectionPage ? subsectionPage.name : sectionPage.name;

    return (
      <BottomBarContainer barContent={this.bottomBarContent} bottomBarClassName="bottom-bar-bg">
        <div>
          <HtmlHead title={`Stride Health - Health Insurance Guide - ${currentPageTitle}`} />
          <div className="guide-parent-container">
            <LeftNav
              sections={sections}
              currentSection={currentSection}
              currentSubsection={currentSubsection} />
            <GuideBody
              sectionHeader={sectionHeader}
              sectionPage={sectionPage}
              subsectionPage={subsectionPage}
              healthGuideTranslations={healthGuideTranslations}
              trackAction={trackAction} />
          </div>
          <FullFooter />
        </div>
      </BottomBarContainer>
    );
  }
}

export default Guide;
